import PropTypes from 'prop-types'
import styled from 'styled-components'

import { container } from '../../mixins'

const Wrap = styled.div`
  ${container};
`
const Container = ({ children, bgColor = 'transparent' }) => {
  return <Wrap bgColor={bgColor}>{children}</Wrap>
}

Container.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}

export { Container }
